// Helpers generici
var modalHandler = null;
var viewInfoBox = true;
class Utils {
  getViewInfoBox() {
    return viewInfoBox;
  }
  setViewInfoBox(val) {
    viewInfoBox = val;
  }
  checkEqualOpp(n, voted, maxVotes) {
    if (voted.length < maxVotes) return true;
    //console.log("check equal opps. MaxVotes: %s", maxVotes);
    var male = voted.filter(candidate => {
      return candidate.gender === "male";
    });
    var female = voted.filter(candidate => {
      return candidate.gender === "female";
    });
    //console.log("male: %s--------female:%s", male.length, female.length);
    if (
      (male.length != female.length && n === 2) ||
      (Math.abs(male.length - female.length) > 1 && n === 3)
    ) {
      // alert("pari opportunità!!");
      return false;
    } else return true;
  }
  checkEqualOpp2(n, voted, maxVotes) {
    //console.log("check equal opps. MaxVotes: %s", maxVotes);
    var male = voted.filter(candidate => {
      return candidate === "male";
    });
    var female = voted.filter(candidate => {
      return candidate === "female";
    });
    //console.log("male: %s--------female:%s", male.length, female.length);
    if (n === 2 && voted.length < maxVotes) {
      return male.length - female.length;
    }
    if (n === 3 && voted.length < maxVotes) {
      if (male.length >= 2) return 1;
      if (female.length >= 2) return -1;
    } else return 0;
  }
  unorderedContests(contestList) {
    return contestList.filter(contest => {
      return contest.Category === null;
    });
  }
  orderedContests(contestList) {
    //TODO: iniefficiente, sistemare
    var orderedContests = contestList.filter(contest => {
      return contest.Category !== null;
    });
    var processed = [];
    var contestGroups = [];
    orderedContests.forEach(contest => {
      if (!processed.includes(contest.Category))
        processed.push(contest.Category);
    });
    processed.forEach((group, index) => {
      var contests = [];
      orderedContests.forEach((contest, index2) => {
        if (contest.Category === group) contests.push(contest);
      });
      contestGroups.push({ name: group, elements: contests });
    });
    return contestGroups;
  }

  modalOpened(id) {
    if (modalHandler != null) {
      this.removeModalHandler();
    }

    //il contenitore della modale aperta
    let modalContainer = document.querySelector(id);

    //aggiunge un listener al focus sul documento
    document.addEventListener(
      "focusin",
      (modalHandler = function(event) {
        //calcola se l'evento è scaturito da un elemento interno alla modale
        let isFocusInsideModal = modalContainer.contains(event.target);

        //se l'evento non è scaturito da un elemento interno alla modale
        if (!isFocusInsideModal) {
          //previene comunque il comportamento di default
          event.preventDefault();

          let focusable = modalContainer.querySelectorAll(
            "input,a,button:enabled"
          );

          //se ci sono elementi a cui dare il focus (dovrebbe sempre essere true)
          if (focusable.length) {
            //prende il primo elemento, l'ultimo elemento e memorizza se viene premuto shift
            let first = focusable[0];
            let last = focusable[focusable.length - 1];
            let shift = event.shiftKey;

            //se stato premuto shift
            if (shift) {
              //dà il focus all'ultimo elemento
              last.focus();
            } else {
              //dà il focus al primo elemento
              first.focus();
            }
          }

          return;
        }
      })
    );
  }

  removeModalHandler() {
    document.removeEventListener("focusin", modalHandler);
  }

  handleTabNavigation(event, tabsId, choicesId, footerId, closeId) {
    let focusable = [];
    let i = 0;

    let focusableCloseButton = [];
    if (closeId != null && document.querySelector(closeId) != null) {
      focusableCloseButton = document
        .querySelector(closeId)
        .querySelectorAll("input,a,button:enabled"); //close button
      for (i = 0; i < focusableCloseButton.length; i++) {
        focusable[i] = focusableCloseButton[i];
      }
    }

    let focusableTab = [];
    if (tabsId != null && document.querySelector(tabsId) != null) {
      if (
        (focusableTab = document
          .querySelector(tabsId)
          .querySelector(".md-tabs-navigation")) != null
      ) {
        focusableTab = document
          .querySelector(tabsId)
          .querySelector(".md-tabs-navigation")
          .querySelectorAll("input,a,button:enabled"); //tabs
      } else {
        //no tabs
        focusableTab = document
          .querySelector(tabsId)
          .querySelectorAll("input,a,button:enabled"); //tabs
      }
      for (let l = 0; l < focusableTab.length; l++) {
        focusable[i] = focusableTab[l];
        i++;
      }
    }

    let focusableCandidates = [];
    if (choicesId != null && document.querySelector(choicesId) != null) {
      focusableCandidates = document
        .querySelector(choicesId)
        .querySelectorAll("input,a,button:enabled"); //candidates
      for (let k = 0; k < focusableCandidates.length; k++) {
        focusable[i] = focusableCandidates[k];
        i++;
      }
    }

    let focusableVoteButton = [];
    if (footerId != null && document.querySelector(footerId) != null) {
      focusableVoteButton = document
        .querySelector(footerId)
        .querySelectorAll("input,a,button:enabled"); //footer
      for (let j = 0; j < focusableVoteButton.length; j++) {
        focusable[i] = focusableVoteButton[j];
        i++;
      }
    }

    /* console.log("focusable " + focusable.length);
    for (let i = 0; i < focusable.length; i++) {
      console.log("i " + i + ": " + focusable[i].id);
    } */

    //se ci sono elementi a cui dare il focus (dovrebbe sempre essere true)
    if (focusable.length) {
      //prende il primo elemento, l'ultimo elemento e memorizza se viene premuto shift
      let first = focusable[0];
      let last = focusable[focusable.length - 1];
      let shift = event.shiftKey;

      //se l'evento è scaturito da un elemento interno della dialog
      if (this.nodelistContains(focusable, event.target)) {
        //se si tratta del primo elemento ed è stato premuto shift
        if (shift && event.target === first) {
          event.preventDefault();
          //dà il focus all'ultimo elemento
          last.focus();
        }
        //se si tratta dell'ultimo elemento e non è stato premuto shift
        else if (!shift && event.target === last) {
          event.preventDefault();
          //dà il focus al primo elemento
          first.focus();
        } else {
          event.preventDefault();
          let index = Array.from(focusable).indexOf(event.target);
          if (shift) {
            focusable[index - 1]?.focus();
          } else {
            focusable[index + 1]?.focus();
          }
        }

        //if (index < focusable.length - 1) focusable[index + 1].focus();
      } else {
        //se l'evento non scaturisce da un elemento che si trova all'interno della dialog
        event.preventDefault();

        if (shift) {
          last.focus();
        } else {
          first.focus();
        }
      }
    }
  }

  nodelistContains(nodelist, obj) {
    if (-1 < Array.from(nodelist).indexOf(obj)) return true;

    return false;
  }
}

export default Utils;
